module.exports = __webpack_public_path__ + "static/media/logo.fa63e671.png";